import React from "react";

const About = () => (
	<section className="py-16 max-w-5xl mx-auto" id="about">
		<h3 className="text-4xl font-bold mb-4 text-[#ff7200]">About Us</h3>
		<p className="text-[#4e4e4e] text-lg">
			Family Depot Limited combines reliable facility management services with
			innovative IT solutions. We ensure efficiency and integrity in all our
			operations, helping clients focus on what matters most.
		</p>
	</section>
);

export default About;
